import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { CategoriaHubSection as Original } from 'components/organisms'
import {
  CategoriaHubSectionSettings,
  CategoriaHubSectionFloatingSettings,
} from './CategoriaHubSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { categoriaHubCardItemParams } from '../CategoriaHubCard'

export const defaultProps = {}

export const categoriaHubSectionItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  children: getItemChildren(enabled, children?.[0], categoriaHubCardItemParams),
})

export const dynamicProps = []

export const CategoriaHubSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-categoria-hub-section ${props.className}`}
      >
        <Original
          item={categoriaHubSectionItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

CategoriaHubSection.craft = withCraft({
  name: 'CategoriaHubSection',
  defaultProps: defaultProps,
  settings: CategoriaHubSectionSettings,
  floatingSettings: CategoriaHubSectionFloatingSettings,
})
